// Centralized translations for Bow League
// Supported: fr (default), en, ar (RTL)

export const LANGUAGES = [
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "en", label: "English", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
];

const dict = {
  fr: {
    brand: "Bow League",
    common: {
      back: "Retour",
      save: "Enregistrer",
      saving: "Enregistrement...",
      loading: "Chargement...",
      cancel: "Annuler",
      start: "Démarrer",
      finish: "Terminer",
      open: "Ouvrir",
      confirm: "Confirmer",
      yes: "Oui",
      no: "Non",
    },
    landing: {
      tagline: "Scoring en direct · Multi-joueurs",
      title_1: "Chaque flèche.",
      title_2: "Chaque point.",
      title_3: "Compté en direct.",
      desc: "Organisez des tirs de qualification, des duels en arc à poulies ou des matchs olympiques avec un code de salle partageable. Votre club, votre format, synchronisés en temps réel.",
      cta_google: "Connexion avec Google",
      cta_learn: "En savoir plus",
      sign_in: "Connexion",
      feature_qual_title: "Qualification",
      feature_qual_desc: "72 flèches · 12 volées de 6 · cible 10 zones",
      feature_match_title: "Match",
      feature_match_desc: "Recurve par sets · Compound cumulatif",
      feature_solo_title: "Entraînement solo",
      feature_solo_desc: "Personnalisez volées et flèches par volée",
    },
    dashboard: {
      control_room: "Salle de contrôle",
      welcome: "Bon retour,",
      subtitle: "Choisis un format. Héberge un match. Ou tire en solo.",
      tile_new_match: "Nouveau match",
      tile_host: "Match",
      tile_host_sub: "En ligne",
      tile_host_desc: "Génère un code. Partage-le. Marquez ensemble en direct.",
      tile_join_label: "Rejoindre",
      tile_settings: "Paramètres",
      resume: "Reprendre",
      last_session: "Dernière session",
      tile_join_title: "Entrer le code",
      tile_solo_label: "Entraînement",
      tile_solo_title: "Tir compté",
      tile_history_label: "Archive",
      tile_history_title: "Historique & stats",
      tile_history_desc: "Tes sessions et matchs précédents",
      tile_rules_label: "Règles",
      tile_legal_label: "Légal",
      tile_legal_title: "Légal",
      tile_legal_desc: "Mentions, confidentialité, CGU",
      tile_rules_title: "Formats & règles",
      tile_rules_desc: "Qualification, Recurve, Compound, Solo",
    },
    settings: {
      title: "Paramètres",
      identity: "Identité",
      your_id: "Ton identifiant d'archer",
      nickname: "Pseudo",
      nickname_placeholder: "ex. Robin",
      preset_avatars: "Avatars prédéfinis",
      custom_upload: "Image personnalisée",
      upload_btn: "Téléverser une image (max 2 Mo)",
      custom_selected: "Avatar personnalisé sélectionné",
      language: "Langue",
      save_profile: "Enregistrer le profil",
      saved: "Profil enregistré",
      save_error: "Impossible d'enregistrer le profil",
      image_too_big: "L'image doit faire < 2 Mo",
      security: "Sécurité",
      change_pin: "Changer le code PIN",
      current_pin: "PIN actuel",
      new_pin: "Nouveau PIN",
      confirm_pin: "Confirmer le nouveau PIN",
      pin_hint: "4 ou 6 chiffres",
      change_pin_btn: "Mettre à jour le PIN",
      pin_changed: "PIN mis à jour",
      pin_mismatch: "Les deux PIN ne correspondent pas",
      pin_invalid: "Le PIN doit faire 4 ou 6 chiffres",
      pin_current_wrong: "PIN actuel incorrect",
      pin_error: "Impossible de changer le PIN",
    },
    target: {
      arrow: "Flèche",
      aim_hint: "Touche la cible pour viser",
      validate: "Valider la flèche",
      undo_last: "Annuler dernière",
      confirm_end: "Confirmer la volée",
      pts: "pts",
      impacts_title: "Carte des impacts",
      impacts_note: "Seules les flèches placées sur la cible sont affichées",
    },
    misc: {
      session_name: "Nom de la session",
      optional: "optionnel",
      session_name_ph: "ex : Paris 2024",
      include_x: "Inclure le X (10 intérieur)",
      yes: "Oui",
      no: "Non",
      x_on: "Blason standard avec le X : le 10 intérieur est compté séparément.",
      x_off: "Blason standard sans X : le centre vaut 10.",
      num_series: "Nombre de séries",
      spectator_code: "Code spectateur",
      code_copied: "Code copié !",
      view_impacts: "Voir la carte des impacts",
      place_on_target: "Placer sur la cible",
      last_active_session: "Dernière session active",
      series: "Série",
      total_of: "Total des",
      series_plural: "séries",
      end_word: "Volée",
      total: "Total",
      session_finished: "Session terminée",
      finished: "Terminé",
      auto_refresh: "Rafraîchissement automatique toutes les 5 secondes.",
      display_name: "Nom affiché",
      username: "Identifiant",
      create_account: "Créer mon compte",
      email: "Adresse e-mail",
      email_ph: "ex : robin@mail.com",
      email_hint: "Sert uniquement à récupérer ton compte si tu oublies ton PIN.",
      ident_hint: "4 à 20 caractères : lettres, chiffres, . _ -",
      name_ph: "ex : Robin des Bois",
      username_ph: "ex : robin42",
      points_detail: "Détail des points",
      match_over: "Match terminé !",
      confirm_score: "Confirmation du score",
      set_pts: "pts de set",
      archer_reached: "Un archer a atteint",
      six_points: "6 points",
      auto_finish: "— le match se termine automatiquement.",
      scores_correct: "Ces scores sont-ils corrects ?",
      correct_btn: "Corriger",
      confirm: "Confirmer",
      finish_match: "Terminer le match",
      in_progress: "En cours",
      final_score: "Score final",
    },
    appearance: {
      title: "Apparence",
      desc: "Choisis le thème de l'application.",
      dark: "Sombre",
      light: "Clair",
    },
    push: {
      title: "Notifications",
      desc: "Reçois une notification quand tu as une demande d'ami ou une invitation.",
      enable: "Activer les notifications",
      disable: "Désactiver sur cet appareil",
      enabled: "Notifications activées",
      disabled: "Notifications désactivées",
      denied: "Notifications bloquées par le navigateur. Autorise-les dans les réglages du site.",
      unsupported: "Non pris en charge par ce navigateur. Sur iPhone, installe d'abord l'app sur l'écran d'accueil.",
      error: "Activation impossible",
    },
    danger: {
      title: "Supprimer mon compte",
      warn: "Cette action est définitive : ton compte, tes sessions et tes statistiques seront supprimés.",
      start: "Supprimer mon compte",
      pin_label: "Saisis ton PIN pour confirmer",
      next: "Continuer",
      sure_title: "Tu es vraiment sûr ?",
      sure_text: "Toutes tes données seront effacées. Il n'y a aucun retour en arrière.",
      cancel: "Annuler",
      confirm: "Oui, supprimer définitivement",
      deleted: "Compte supprimé",
      error: "Suppression impossible",
    },
    reset: {
      forgot: "Identifiants oubliés ?",
      title: "Récupérer mes identifiants",
      identifier: "Identifiant ou e-mail",
      identifier_hint: "Si tu as oublié ton identifiant, saisis ton adresse e-mail.",
      what: "Que veux-tu récupérer ?",
      want_identifiant: "Mon identifiant",
      want_pin: "Mon PIN",
      pick_one: "Coche au moins une option",
      send: "Envoyer",
      sent: "Si un compte existe, un e-mail vient d'être envoyé. Vérifie ta boîte (et les spams).",
      new_title: "Choisis un nouveau PIN",
      new_pin: "Nouveau PIN",
      confirm_pin: "Confirmer le PIN",
      save: "Enregistrer",
      done: "PIN modifié. Tu peux te connecter.",
      mismatch: "Les PIN ne correspondent pas",
      invalid_pin: "Le PIN doit faire 4 ou 6 chiffres",
      bad_link: "Lien invalide ou expiré",
      back_login: "Retour à la connexion",
      change_email: "Changer mon e-mail",
      current_email: "E-mail actuel",
      new_email: "Nouvel e-mail",
      current_pin: "PIN actuel",
      email_saved: "E-mail mis à jour",
      email_error: "Impossible de mettre à jour l'e-mail",
    },
    stats: {
      tab_history: "Historique",
      sort: "Trier",
      sort_date_desc: "Plus récent",
      sort_date_asc: "Plus ancien",
      sort_score_desc: "Moy./flèche ↓",
      sort_score_asc: "Moy./flèche ↑",
      tab_stats: "Statistiques",
      p3d: "3 jours", p1w: "1 sem.", p2w: "2 sem.", p1m: "1 mois", p3m: "3 mois", p6m: "6 mois", pall: "Tout",
      arrows_counted: "Flèches comptées",
      avg_per_arrow: "Moyenne / flèche",
      avg_360: "Score moyen /360",
      best_360: "Meilleur /360",
      sessions: "Sessions",
      tens: "Nombre de 10",
      xs: "Nombre de X",
      impact_title: "Impact moyen",
      value_mean: "Valeur moyenne",
      distance_center: "Distance au centre",
      dispersion: "Dispersion",
      tendency_at: "Tendance vers",
      oclock: "h",
      no_tendency: "Groupement centré, pas de tendance marquée",
      impact_note: "Valeur, distance au centre et direction calculées séparément.",
      impacts_count: "impacts placés",
      curve_title: "Progression /360",
      no_data: "Pas assez de données sur cette période",
    },
    chrono: {
      title: "Chrono",
      tile_label: "Entraînement",
      tile_title: "Chrono",
      tile_desc: "Minuteur de tir plein écran",
      presets: "Chronos standards",
      my_presets: "Mes chronos",
      arrows3: "3 flèches",
      arrows6: "6 flèches",
      prep: "Préparation (s)",
      shoot: "Tir (s)",
      orange: "Orange à (s)",
      red: "Rouge à (s)",
      times_hint: "Orange/Rouge = secondes restantes avant la fin du tir.",
      save: "Enregistrer",
      start: "Démarrer",
      pause: "Pause",
      resume: "Reprendre",
      restart: "Redémarrer",
      settings: "Paramètres",
      prep_phase: "Préparation",
      shoot_phase: "Tir",
      done: "Temps écoulé",
      name: "Nom du chrono enregistré",
      name_ph: "ex : Entraînement salle",
      fix_fields: "Vérifie les champs : rouge ≤ orange ≤ tir",
    },
    chronopage: {
      awake_on: "Écran maintenu allumé",
      awake_off: "Veille non bloquée",
      audio_hint: "Touche l'écran une fois pour activer le son",
      controls_title: "Manette / clavier",
      controls_desc: "A : démarrer / pause · B : redémarrer (les touches clavier A et B fonctionnent aussi).",
      controls_hint: "Touche A : pause / reprise · Touche B : redémarrer",
      pad_connected: "Manette connectée",
      pad_none: "Aucune manette détectée (appuie sur un bouton)",
      map_play: "Démarrer / Pause",
      map_restart: "Redémarrer",
      map_assign: "Assigner",
      map_press: "Appuie sur un bouton…",
      map_default: "Remettre par défaut",
    },
    delaycam: {
      title: "Delay Cam",
      tile_title: "Delay Cam",
      tile_desc: "Caméra avec délai réglable",
      delay_label: "Délai",
      switch_camera: "Changer de caméra",
      permission_denied: "Accès à la caméra refusé. Autorise-la dans les réglages de ton navigateur.",
      no_camera: "Aucune caméra détectée sur cet appareil.",
      starting: "Démarrage de la caméra...",
    },
    social: {
      title: "Social",
      tab_friends: "Amis",
      tab_requests: "Demandes",
      tab_search: "Ajouter",
      search_ph: "1234 5678",
      search_hint: "Saisis le code ami à 8 chiffres.",
      no_results: "Aucun compte pour ce code",
      my_code: "Mon code ami",
      code_copied: "Code copié",
      find: "Chercher",
      no_friends: "Tu n'as pas encore d'amis.",
      no_requests: "Aucune demande en attente.",
      add: "Ajouter",
      sent: "Envoyée",
      friend: "Ami",
      accept: "Accepter",
      decline: "Refuser",
      remove: "Retirer",
      remove_confirm: "Retirer cet ami ?",
      cancel: "Annuler la demande",
      incoming: "Reçues",
      outgoing: "Envoyées",
      invitations: "Invitations",
      invited_you: "t'invite",
      join: "Rejoindre",
      request_sent: "Demande envoyée",
      now_friends: "Vous êtes maintenant amis",
      error: "Une erreur est survenue",
    },
    share: {
      button: "Partager",
      title: "Partager la session",
      pick: "Choisis les amis à prévenir",
      send: "Envoyer",
      sent_toast: "Invitation envoyée",
      none: "Ajoute des amis pour partager tes sessions.",
    },
    targetcfg: {
      title: "Ta cible",
      face: "Blason",
      full: "Complet",
      trispot_recurve: "Trispot recurve",
      trispot_compound: "Trispot compound",
      x_inner: "X (intérieur)",
      outer_ten: "10 extérieur",
      change: "Cible",
      confirm: "Valider ma cible",
    },
    rules: {
      label: "Règles",
      title: "Référence des formats",
      qualification_name: "Qualification",
      qualification_body: "72 flèches au total, en 12 volées de 6. X=10 (intérieur), 10, 9, ... 1, M (manqué) = 0. Le meilleur total gagne.",
      recurve_name: "Match Recurve (olympique)",
      recurve_body: "5 sets de 3 flèches. Gagner un set = 2 points de set, égalité = 1 chacun. Premier à 6 points de set gagne. À 5-5, tir de barrage 1 flèche, la plus proche du centre l'emporte.",
      compound_name: "Match Compound",
      compound_body: "5 volées de 3 flèches. Scores cumulés. Le meilleur total sur 15 flèches gagne. En cas d'égalité, barrage plus proche du centre.",
      solo_name: "Entraînement solo",
      solo_body: "Définis tes propres nombres de volées et flèches par volée. Pas d'adversaire, juste ton score.",
    },
    match_create: {
      title: "Nouveau match",
      step1: "Étape 1",
      step1_title: "Choisis un format",
      qualification: "Qualification",
      qualification_desc: "72 flèches · 12 volées de 6",
      recurve: "Match Recurve",
      recurve_desc: "Système de sets · 5 sets de 3 · Premier à 6 points",
      compound: "Match Compound",
      compound_desc: "Cumulatif · 5 volées de 3",
      step2: "Étape 2",
      step2_title: "Ajuste les réglages",
      sets: "Sets",
      ends: "Volées",
      arrows_per_end: "Flèches par volée",
      cta_create: "Générer le code de salle",
      creating: "Création...",
      error_create: "Impossible de créer le match",
    },
    match_join: {
      title: "Rejoindre un match",
      label: "Entrer le code",
      heading: "Tu as un code de salle ?",
      desc: "Saisis le code à 6 caractères partagé par l'hôte.",
      cta: "Rejoindre",
      joining: "Connexion...",
      not_found: "Match introuvable",
    },
    match_live: {
      leave: "Quitter",
      leave_confirm: "Quitter le match ? Tes scores seront supprimés.",
      waiting: "Salle d'attente",
      live: "En direct",
      finished: "Terminé",
      share_code: "Partage ce code",
      players_joined: "joueur(s) rejoint(s)",
      start_match: "Démarrer le match",
      started: "Match démarré",
      start_error: "Impossible de démarrer",
      finish_match: "Terminer le match",
      finished_toast: "Match terminé",
      finish_error: "Impossible de terminer",
      end_match: "Mettre fin au match",
      end: "Volée",
      arrow: "Flèche",
      reset_last: "Annuler dernière",
      reset_error: "Impossible d'annuler",
      all_shot: "Toutes les flèches tirées !",
      final_score: "Score final :",
      you: "Toi",
      opponent: "Adversaire",
      set_points: "Points de sets :",
      total_arrows: "Total flèches :",
      submit_error: "Impossible d'envoyer le score",
      // Tiebreak
      tiebreak_title: "Barrage",
      tiebreak_desc_recurve: "Les deux archers sont à 5-5. Tire 1 flèche, la plus proche du centre gagne.",
      tiebreak_desc_compound: "Égalité. Tire 1 flèche de barrage pour départager.",
      shootoff_waiting: "En attente de l'adversaire...",
      shootoff_shot: "Flèche tirée",
      still_tied: "Toujours à égalité. L'hôte doit désigner le plus proche du centre.",
      who_closest: "Qui est le plus proche du centre ?",
      declare_winner: "Désigner vainqueur",
      winner_declared: "Vainqueur désigné",
      winner: "Vainqueur",
      cancel_winner: "Annuler désignation",
    },
    solo_setup: {
      title: "Entraînement solo",
      label: "Entraînement",
      heading: "Configure ta session",
      ends: "Volées",
      arrows_per_end: "Flèches par volée",
      cta: "Commencer",
      creating: "Démarrage...",
      error: "Impossible de démarrer",
    },
    solo_live: {
      back: "Retour",
      total: "Total",
      end: "Volée",
      arrow: "Flèche",
      finish: "Terminer la session",
      finished: "Session terminée",
      final: "Score final :",
      end_early: "Arrêter",
      toast_finished: "Session terminée",
      submit_error: "Impossible d'envoyer",
    },
    history: {
      title: "Historique",
      label: "Archive",
      heading: "Tes sessions",
      empty: "Aucune session pour le moment. Lance-en une depuis le tableau de bord.",
      open: "Ouvrir →",
      players_suffix: "joueur(s)",
      match_word: "Match",
      delete: "Supprimer",
      delete_confirm_title: "Supprimer cette entrée ?",
      delete_confirm_desc: "Elle sera retirée de ton historique. Cette action est définitive.",
      delete_cancel: "Annuler",
      delete_ok: "Supprimer",
      deleted: "Entrée supprimée",
      delete_error: "Impossible de supprimer",
    },
    format: {
      qualification: "Qualification",
      recurve: "Recurve",
      compound: "Compound",
      solo: "Solo",
    },
  },

  en: {
    brand: "Bow League",
    common: {
      back: "Back", save: "Save", saving: "Saving...", loading: "Loading...",
      cancel: "Cancel", start: "Start", finish: "Finish", open: "Open",
      confirm: "Confirm", yes: "Yes", no: "No",
    },
    landing: {
      tagline: "Live scoring · Multi-player",
      title_1: "Every arrow.",
      title_2: "Every point.",
      title_3: "Counted live.",
      desc: "Host qualification rounds, compound duels, or Olympic match play with a shareable room code. Your club, your format, synchronized in real time.",
      cta_google: "Sign in with Google",
      cta_learn: "Learn more",
      sign_in: "Sign in",
      feature_qual_title: "Qualification",
      feature_qual_desc: "72 arrows · 12 ends of 6 · 10-zone target",
      feature_match_title: "Match play",
      feature_match_desc: "Recurve set system · Compound cumulative",
      feature_solo_title: "Solo practice",
      feature_solo_desc: "Customize ends and arrows per end",
    },
    dashboard: {
      control_room: "Control room",
      welcome: "Welcome back,",
      subtitle: "Pick a format. Host a match. Or shoot solo.",
      tile_new_match: "New match",
      tile_host: "Match",
      tile_host_sub: "Online",
      tile_host_desc: "Generate a code. Share it. Score together in real time.",
      tile_join_label: "Join",
      tile_settings: "Settings",
      resume: "Resume",
      last_session: "Last session",
      tile_join_title: "Enter code",
      tile_solo_label: "Practice",
      tile_solo_title: "Scored shooting",
      tile_history_label: "Archive",
      tile_history_title: "History & stats",
      tile_history_desc: "Your past sessions and matches",
      tile_rules_label: "Rules",
      tile_legal_label: "Legal",
      tile_legal_title: "Legal",
      tile_legal_desc: "Notices, privacy, terms",
      tile_rules_title: "Formats & rules",
      tile_rules_desc: "Qualification, Recurve, Compound, Solo",
    },
    settings: {
      title: "Settings",
      identity: "Identity",
      your_id: "Your archer ID",
      nickname: "Nickname",
      nickname_placeholder: "e.g. Robin",
      preset_avatars: "Preset avatars",
      custom_upload: "Custom upload",
      upload_btn: "Upload image (max 2MB)",
      custom_selected: "Custom avatar selected",
      language: "Language",
      save_profile: "Save profile",
      saved: "Profile saved",
      save_error: "Could not save profile",
      image_too_big: "Image must be < 2MB",
      security: "Security",
      change_pin: "Change PIN",
      current_pin: "Current PIN",
      new_pin: "New PIN",
      confirm_pin: "Confirm new PIN",
      pin_hint: "4 or 6 digits",
      change_pin_btn: "Update PIN",
      pin_changed: "PIN updated",
      pin_mismatch: "The two PINs don't match",
      pin_invalid: "PIN must be 4 or 6 digits",
      pin_current_wrong: "Current PIN incorrect",
      pin_error: "Could not change PIN",
    },
    target: {
      arrow: "Arrow",
      aim_hint: "Tap the target to aim",
      validate: "Confirm arrow",
      undo_last: "Undo last",
      confirm_end: "Confirm end",
      pts: "pts",
      impacts_title: "Impact map",
      impacts_note: "Only arrows placed on the target are shown",
    },
    misc: {
      session_name: "Session name",
      optional: "optional",
      session_name_ph: "e.g. Paris 2024",
      include_x: "Include the X (inner 10)",
      yes: "Yes",
      no: "No",
      x_on: "Standard face with the X: the inner 10 is counted separately.",
      x_off: "Standard face without X: the center counts as 10.",
      num_series: "Number of series",
      spectator_code: "Spectator code",
      code_copied: "Code copied!",
      view_impacts: "View impact map",
      place_on_target: "Place on target",
      last_active_session: "Last active session",
      series: "Series",
      total_of: "Total of",
      series_plural: "series",
      end_word: "End",
      total: "Total",
      session_finished: "Session finished",
      finished: "Finished",
      auto_refresh: "Auto-refresh every 5 seconds.",
      display_name: "Display name",
      username: "Username",
      create_account: "Create my account",
      email: "Email address",
      email_ph: "e.g. robin@mail.com",
      email_hint: "Only used to recover your account if you forget your PIN.",
      ident_hint: "4 to 20 characters: letters, digits, . _ -",
      name_ph: "e.g. Robin Hood",
      username_ph: "e.g. robin42",
      points_detail: "Points detail",
      match_over: "Match over!",
      confirm_score: "Score confirmation",
      set_pts: "set pts",
      archer_reached: "An archer reached",
      six_points: "6 points",
      auto_finish: "— the match ends automatically.",
      scores_correct: "Are these scores correct?",
      correct_btn: "Correct",
      confirm: "Confirm",
      finish_match: "Finish match",
      in_progress: "In progress",
      final_score: "Final score",
    },
    appearance: {
      title: "Appearance",
      desc: "Choose the app theme.",
      dark: "Dark",
      light: "Light",
    },
    push: {
      title: "Notifications",
      desc: "Get notified when you receive a friend request or an invitation.",
      enable: "Enable notifications",
      disable: "Disable on this device",
      enabled: "Notifications enabled",
      disabled: "Notifications disabled",
      denied: "Notifications blocked by the browser. Allow them in site settings.",
      unsupported: "Not supported by this browser. On iPhone, install the app to your home screen first.",
      error: "Could not enable",
    },
    danger: {
      title: "Delete my account",
      warn: "This is permanent: your account, sessions and stats will be deleted.",
      start: "Delete my account",
      pin_label: "Enter your PIN to confirm",
      next: "Continue",
      sure_title: "Are you really sure?",
      sure_text: "All your data will be erased. There is no going back.",
      cancel: "Cancel",
      confirm: "Yes, delete permanently",
      deleted: "Account deleted",
      error: "Could not delete",
    },
    reset: {
      forgot: "Forgot your details?",
      title: "Recover my details",
      identifier: "Username or email",
      identifier_hint: "If you forgot your username, enter your email address.",
      what: "What do you need?",
      want_identifiant: "My username",
      want_pin: "My PIN",
      pick_one: "Pick at least one option",
      send: "Send",
      sent: "If an account exists, an email has been sent. Check your inbox (and spam).",
      new_title: "Choose a new PIN",
      new_pin: "New PIN",
      confirm_pin: "Confirm PIN",
      save: "Save",
      done: "PIN updated. You can sign in.",
      mismatch: "PINs do not match",
      invalid_pin: "PIN must be 4 or 6 digits",
      bad_link: "Invalid or expired link",
      back_login: "Back to sign in",
      change_email: "Change my email",
      current_email: "Current email",
      new_email: "New email",
      current_pin: "Current PIN",
      email_saved: "Email updated",
      email_error: "Could not update email",
    },
    stats: {
      tab_history: "History",
      sort: "Sort",
      sort_date_desc: "Newest",
      sort_date_asc: "Oldest",
      sort_score_desc: "Avg/arrow ↓",
      sort_score_asc: "Avg/arrow ↑",
      tab_stats: "Statistics",
      p3d: "3 days", p1w: "1 wk", p2w: "2 wks", p1m: "1 mo", p3m: "3 mo", p6m: "6 mo", pall: "All",
      arrows_counted: "Arrows counted",
      avg_per_arrow: "Average / arrow",
      avg_360: "Average score /360",
      best_360: "Best /360",
      sessions: "Sessions",
      tens: "Number of 10s",
      xs: "Number of Xs",
      impact_title: "Average impact",
      value_mean: "Average value",
      distance_center: "Distance to center",
      dispersion: "Dispersion",
      tendency_at: "Tendency toward",
      oclock: " o'clock",
      no_tendency: "Centered grouping, no clear tendency",
      impact_note: "Value, distance to center and direction computed separately.",
      impacts_count: "placed impacts",
      curve_title: "Progression /360",
      no_data: "Not enough data for this period",
    },
    chrono: {
      title: "Timer",
      tile_label: "Training",
      tile_title: "Timer",
      tile_desc: "Full-screen shooting timer",
      presets: "Standard timers",
      my_presets: "My timers",
      arrows3: "3 arrows",
      arrows6: "6 arrows",
      prep: "Preparation (s)",
      shoot: "Shooting (s)",
      orange: "Orange at (s)",
      red: "Red at (s)",
      times_hint: "Orange/Red = seconds left before the end of shooting.",
      save: "Save",
      start: "Start",
      pause: "Pause",
      resume: "Resume",
      restart: "Restart",
      settings: "Settings",
      prep_phase: "Preparation",
      shoot_phase: "Shooting",
      done: "Time up",
      name: "Saved timer name",
      name_ph: "e.g. Indoor training",
      fix_fields: "Check fields: red ≤ orange ≤ shooting",
    },
    chronopage: {
      awake_on: "Screen kept awake",
      awake_off: "Sleep not blocked",
      audio_hint: "Tap the screen once to enable sound",
      controls_title: "Controller / keyboard",
      controls_desc: "A: start / pause · B: restart (keyboard keys A and B work too).",
      controls_hint: "Key A: pause / resume · Key B: restart",
      pad_connected: "Controller connected",
      pad_none: "No controller detected (press a button)",
      map_play: "Start / Pause",
      map_restart: "Restart",
      map_assign: "Assign",
      map_press: "Press a button…",
      map_default: "Reset to default",
    },
    delaycam: {
      title: "Delay Cam",
      tile_title: "Delay Cam",
      tile_desc: "Camera with adjustable delay",
      delay_label: "Delay",
      switch_camera: "Switch camera",
      permission_denied: "Camera access denied. Allow it in your browser settings.",
      no_camera: "No camera detected on this device.",
      starting: "Starting camera...",
    },
    social: {
      title: "Social",
      tab_friends: "Friends",
      tab_requests: "Requests",
      tab_search: "Add",
      search_ph: "1234 5678",
      search_hint: "Enter the 8-digit friend code.",
      no_results: "No account for this code",
      my_code: "My friend code",
      code_copied: "Code copied",
      find: "Search",
      no_friends: "You have no friends yet.",
      no_requests: "No pending requests.",
      add: "Add",
      sent: "Sent",
      friend: "Friend",
      accept: "Accept",
      decline: "Decline",
      remove: "Remove",
      remove_confirm: "Remove this friend?",
      cancel: "Cancel request",
      incoming: "Incoming",
      outgoing: "Outgoing",
      invitations: "Invitations",
      invited_you: "invited you",
      join: "Join",
      request_sent: "Request sent",
      now_friends: "You are now friends",
      error: "Something went wrong",
    },
    share: {
      button: "Share",
      title: "Share session",
      pick: "Pick friends to notify",
      send: "Send",
      sent_toast: "Invitation sent",
      none: "Add friends to share your sessions.",
    },
    targetcfg: {
      title: "Your target",
      face: "Face",
      full: "Full",
      trispot_recurve: "Trispot recurve",
      trispot_compound: "Trispot compound",
      x_inner: "X (inner)",
      outer_ten: "Outer 10",
      change: "Target",
      confirm: "Confirm my target",
    },
    rules: {
      label: "Rules",
      title: "Format reference",
      qualification_name: "Qualification",
      qualification_body: "72 arrows total, shot in 12 ends of 6. X=10 (inner), 10, 9, ... 1, M (miss) = 0. Highest total wins.",
      recurve_name: "Recurve (Olympic) match",
      recurve_body: "5 sets of 3 arrows. Winner of a set = 2 set points, tie = 1 each. First to 6 set points wins. On 5–5, one-arrow shoot-off, closest to center wins.",
      compound_name: "Compound match",
      compound_body: "5 ends of 3 arrows. Scores are cumulative. Highest total over 15 arrows wins. On tie, shoot-off closest to center.",
      solo_name: "Solo practice",
      solo_body: "Set your own number of ends and arrows per end. No opponent, just your score.",
    },
    match_create: {
      title: "New Match",
      step1: "Step 1",
      step1_title: "Choose a format",
      qualification: "Qualification",
      qualification_desc: "72 arrows · 12 ends of 6",
      recurve: "Recurve Match",
      recurve_desc: "Set system · 5 sets of 3 · First to 6 points",
      compound: "Compound Match",
      compound_desc: "Cumulative · 5 ends of 3",
      step2: "Step 2",
      step2_title: "Adjust settings",
      sets: "Sets",
      ends: "Ends",
      arrows_per_end: "Arrows per end",
      cta_create: "Generate room code",
      creating: "Creating...",
      error_create: "Could not create match",
    },
    match_join: {
      title: "Join match",
      label: "Enter code",
      heading: "Got a room code?",
      desc: "Type the 6-character code shared by the host.",
      cta: "Join",
      joining: "Joining...",
      not_found: "Match not found",
    },
    match_live: {
      leave: "Leave",
      leave_confirm: "Leave the match? Your scores will be deleted.",
      waiting: "Waiting room",
      live: "Live",
      finished: "Finished",
      share_code: "Share this code",
      players_joined: "player(s) joined",
      start_match: "Start match",
      started: "Match started",
      start_error: "Could not start",
      finish_match: "Finish match",
      finished_toast: "Match finished",
      finish_error: "Could not finish",
      end_match: "End match",
      end: "End",
      arrow: "Arrow",
      reset_last: "Reset last",
      reset_error: "Could not undo",
      all_shot: "All arrows shot!",
      final_score: "Final score:",
      you: "You",
      opponent: "Opponent",
      set_points: "Set points:",
      total_arrows: "Total arrows:",
      submit_error: "Could not submit score",
      tiebreak_title: "Shoot-off",
      tiebreak_desc_recurve: "Both archers tied at 5-5. Shoot 1 arrow, closest to center wins.",
      tiebreak_desc_compound: "Tied. Shoot 1 arrow to break the tie.",
      shootoff_waiting: "Waiting for opponent...",
      shootoff_shot: "Arrow shot",
      still_tied: "Still tied. Host, pick the arrow closest to the center.",
      who_closest: "Who is closest to the center?",
      declare_winner: "Declare winner",
      winner_declared: "Winner declared",
      winner: "Winner",
      cancel_winner: "Cancel pick",
    },
    solo_setup: {
      title: "Solo practice",
      label: "Practice",
      heading: "Configure your session",
      ends: "Ends",
      arrows_per_end: "Arrows per end",
      cta: "Start shooting",
      creating: "Starting...",
      error: "Could not start session",
    },
    solo_live: {
      back: "Back",
      total: "Total",
      end: "End",
      arrow: "Arrow",
      finish: "Finish session",
      finished: "Session finished",
      final: "Final score:",
      end_early: "End session",
      toast_finished: "Session finished",
      submit_error: "Could not submit",
    },
    history: {
      title: "History",
      label: "Archive",
      heading: "Your sessions",
      empty: "No sessions yet. Start one from the dashboard.",
      open: "Open →",
      players_suffix: "player(s)",
      match_word: "Match",
      delete: "Delete",
      delete_confirm_title: "Delete this entry?",
      delete_confirm_desc: "It will be removed from your history. This cannot be undone.",
      delete_cancel: "Cancel",
      delete_ok: "Delete",
      deleted: "Entry deleted",
      delete_error: "Could not delete",
    },
    format: {
      qualification: "Qualification",
      recurve: "Recurve",
      compound: "Compound",
      solo: "Solo",
    },
  },

  ar: {
    brand: "Bow League",
    common: {
      back: "رجوع", save: "حفظ", saving: "جارٍ الحفظ...", loading: "جارٍ التحميل...",
      cancel: "إلغاء", start: "ابدأ", finish: "إنهاء", open: "فتح",
      confirm: "تأكيد", yes: "نعم", no: "لا",
    },
    landing: {
      tagline: "تسجيل مباشر · متعدد اللاعبين",
      title_1: "كل سهم.",
      title_2: "كل نقطة.",
      title_3: "محسوبة مباشرة.",
      desc: "استضف جولات تأهيل، أو مباريات القوس المركّب، أو مباريات أولمبية برمز غرفة قابل للمشاركة. نادِيك، تنسيقك، متزامن فورًا.",
      cta_google: "تسجيل الدخول بواسطة Google",
      cta_learn: "اعرف المزيد",
      sign_in: "تسجيل الدخول",
      feature_qual_title: "تأهيل",
      feature_qual_desc: "72 سهمًا · 12 جولة من 6 · هدف 10 مناطق",
      feature_match_title: "مباراة",
      feature_match_desc: "نظام أشواط القوس الاسترداد · تراكمي القوس المركّب",
      feature_solo_title: "تدريب فردي",
      feature_solo_desc: "خصّص عدد الجولات والأسهم لكل جولة",
    },
    dashboard: {
      control_room: "غرفة التحكم",
      welcome: "مرحبًا بعودتك،",
      subtitle: "اختر تنسيقًا. استضف مباراة. أو ارمِ منفردًا.",
      tile_new_match: "مباراة جديدة",
      tile_host: "مباراة",
      tile_host_sub: "عبر الإنترنت",
      tile_host_desc: "أنشئ رمزًا، شاركه، وسجّلوا معًا مباشرةً.",
      tile_join_label: "انضم",
      tile_settings: "الإعدادات",
      resume: "استئناف",
      last_session: "آخر جلسة",
      tile_join_title: "أدخل الرمز",
      tile_solo_label: "تدريب",
      tile_solo_title: "رمي محتسب",
      tile_history_label: "الأرشيف",
      tile_history_title: "السجل والإحصائيات",
      tile_history_desc: "جلساتك ومبارياتك السابقة",
      tile_rules_label: "القواعد",
      tile_legal_label: "قانوني",
      tile_legal_title: "قانوني",
      tile_legal_desc: "إشعارات، خصوصية، شروط",
      tile_rules_title: "التنسيقات والقواعد",
      tile_rules_desc: "تأهيل، استرداد، مركّب، فردي",
    },
    settings: {
      title: "الإعدادات",
      identity: "الهوية",
      your_id: "بطاقتك كرامٍ",
      nickname: "اللقب",
      nickname_placeholder: "مثال: روبن",
      preset_avatars: "صور رمزية جاهزة",
      custom_upload: "تحميل مخصص",
      upload_btn: "رفع صورة (حد أقصى 2 ميغابايت)",
      custom_selected: "تم اختيار الصورة المخصصة",
      language: "اللغة",
      save_profile: "حفظ الملف الشخصي",
      saved: "تم حفظ الملف",
      save_error: "تعذر حفظ الملف",
      image_too_big: "يجب أن تكون الصورة أقل من 2 ميغابايت",
      security: "الأمان",
      change_pin: "تغيير الرمز السري",
      current_pin: "الرمز الحالي",
      new_pin: "الرمز الجديد",
      confirm_pin: "تأكيد الرمز الجديد",
      pin_hint: "4 أو 6 أرقام",
      change_pin_btn: "تحديث الرمز",
      pin_changed: "تم تحديث الرمز",
      pin_mismatch: "الرمزان غير متطابقين",
      pin_invalid: "يجب أن يكون الرمز 4 أو 6 أرقام",
      pin_current_wrong: "الرمز الحالي غير صحيح",
      pin_error: "تعذر تغيير الرمز",
    },
    target: {
      arrow: "السهم",
      aim_hint: "المس الهدف للتصويب",
      validate: "تأكيد السهم",
      undo_last: "تراجع عن الأخير",
      confirm_end: "تأكيد الرمية",
      pts: "نقاط",
      impacts_title: "خريطة الإصابات",
      impacts_note: "تُعرض فقط الأسهم الموضوعة على الهدف",
    },
    misc: {
      session_name: "اسم الجلسة",
      optional: "اختياري",
      session_name_ph: "مثال: باريس 2024",
      include_x: "تضمين الـ X (المركز الداخلي)",
      yes: "نعم",
      no: "لا",
      x_on: "هدف قياسي مع الـ X: تُحتسب العشرة الداخلية بشكل منفصل.",
      x_off: "هدف قياسي بدون X: المركز يساوي 10.",
      num_series: "عدد المجموعات",
      spectator_code: "رمز المشاهدة",
      code_copied: "تم نسخ الرمز!",
      view_impacts: "عرض خريطة الإصابات",
      place_on_target: "الوضع على الهدف",
      last_active_session: "آخر جلسة نشطة",
      series: "مجموعة",
      total_of: "إجمالي",
      series_plural: "مجموعات",
      end_word: "رمية",
      total: "المجموع",
      session_finished: "انتهت الجلسة",
      finished: "منتهية",
      auto_refresh: "تحديث تلقائي كل 5 ثوانٍ.",
      display_name: "الاسم المعروض",
      username: "المعرّف",
      create_account: "إنشاء حسابي",
      email: "البريد الإلكتروني",
      email_ph: "مثال: robin@mail.com",
      email_hint: "يُستخدم فقط لاستعادة حسابك إذا نسيت الرمز.",
      ident_hint: "من 4 إلى 20 حرفًا: حروف، أرقام، . _ -",
      name_ph: "مثال: روبن هود",
      username_ph: "مثال: robin42",
      points_detail: "تفاصيل النقاط",
      match_over: "انتهت المباراة!",
      confirm_score: "تأكيد النتيجة",
      set_pts: "نقاط الشوط",
      archer_reached: "بلغ أحد الرماة",
      six_points: "6 نقاط",
      auto_finish: "— تنتهي المباراة تلقائيًا.",
      scores_correct: "هل هذه النتائج صحيحة؟",
      correct_btn: "تصحيح",
      confirm: "تأكيد",
      finish_match: "إنهاء المباراة",
      in_progress: "جارية",
      final_score: "النتيجة النهائية",
    },
    appearance: {
      title: "المظهر",
      desc: "اختر مظهر التطبيق.",
      dark: "داكن",
      light: "فاتح",
    },
    push: {
      title: "الإشعارات",
      desc: "استقبل إشعارًا عند وصول طلب صداقة أو دعوة.",
      enable: "تفعيل الإشعارات",
      disable: "تعطيل على هذا الجهاز",
      enabled: "الإشعارات مفعّلة",
      disabled: "الإشعارات معطّلة",
      denied: "الإشعارات محظورة في المتصفح. اسمح بها في إعدادات الموقع.",
      unsupported: "غير مدعوم في هذا المتصفح. على iPhone ثبّت التطبيق على الشاشة الرئيسية أولًا.",
      error: "تعذّر التفعيل",
    },
    danger: {
      title: "حذف حسابي",
      warn: "هذا الإجراء نهائي: سيُحذف حسابك وجلساتك وإحصاءاتك.",
      start: "حذف حسابي",
      pin_label: "أدخل رمزك للتأكيد",
      next: "متابعة",
      sure_title: "هل أنت متأكد فعلًا؟",
      sure_text: "ستُمحى جميع بياناتك. لا رجعة في ذلك.",
      cancel: "إلغاء",
      confirm: "نعم، احذف نهائيًا",
      deleted: "حُذف الحساب",
      error: "تعذّر الحذف",
    },
    reset: {
      forgot: "نسيت بياناتك؟",
      title: "استعادة بياناتي",
      identifier: "المعرّف أو البريد",
      identifier_hint: "إن نسيت معرّفك، أدخل بريدك الإلكتروني.",
      what: "ماذا تريد استعادته؟",
      want_identifiant: "معرّفي",
      want_pin: "رمزي",
      pick_one: "اختر خيارًا واحدًا على الأقل",
      send: "إرسال",
      sent: "إن وُجد حساب، فقد أُرسل بريد. تحقق من صندوقك (والبريد المزعج).",
      new_title: "اختر رمزًا جديدًا",
      new_pin: "الرمز الجديد",
      confirm_pin: "تأكيد الرمز",
      save: "حفظ",
      done: "تم تغيير الرمز. يمكنك تسجيل الدخول.",
      mismatch: "الرمزان غير متطابقين",
      invalid_pin: "يجب أن يتكون الرمز من 4 أو 6 أرقام",
      bad_link: "رابط غير صالح أو منتهٍ",
      back_login: "العودة لتسجيل الدخول",
      change_email: "تغيير بريدي",
      current_email: "البريد الحالي",
      new_email: "البريد الجديد",
      current_pin: "الرمز الحالي",
      email_saved: "تم تحديث البريد",
      email_error: "تعذر تحديث البريد",
    },
    stats: {
      tab_history: "السجل",
      sort: "ترتيب",
      sort_date_desc: "الأحدث",
      sort_date_asc: "الأقدم",
      sort_score_desc: "المعدل/سهم ↓",
      sort_score_asc: "المعدل/سهم ↑",
      tab_stats: "الإحصائيات",
      p3d: "3 أيام", p1w: "أسبوع", p2w: "أسبوعان", p1m: "شهر", p3m: "3 أشهر", p6m: "6 أشهر", pall: "الكل",
      arrows_counted: "الأسهم المحتسبة",
      avg_per_arrow: "المعدل / سهم",
      avg_360: "متوسط النتيجة /360",
      best_360: "أفضل /360",
      sessions: "الجلسات",
      tens: "عدد العشرات",
      xs: "عدد X",
      impact_title: "الإصابة المتوسطة",
      value_mean: "القيمة المتوسطة",
      distance_center: "المسافة إلى المركز",
      dispersion: "التشتت",
      tendency_at: "ميل نحو",
      oclock: " ساعة",
      no_tendency: "تجمّع مركزي، دون ميل واضح",
      impact_note: "القيمة والمسافة إلى المركز والاتجاه محسوبة بشكل منفصل.",
      impacts_count: "إصابات موضوعة",
      curve_title: "التطور /360",
      no_data: "بيانات غير كافية لهذه الفترة",
    },
    chrono: {
      title: "المؤقّت",
      tile_label: "تدريب",
      tile_title: "المؤقّت",
      tile_desc: "مؤقّت رماية بملء الشاشة",
      presets: "مؤقّتات قياسية",
      my_presets: "مؤقّتاتي",
      arrows3: "3 أسهم",
      arrows6: "6 أسهم",
      prep: "التحضير (ث)",
      shoot: "الرمي (ث)",
      orange: "برتقالي عند (ث)",
      red: "أحمر عند (ث)",
      times_hint: "برتقالي/أحمر = الثواني المتبقية قبل نهاية الرمي.",
      save: "حفظ",
      start: "بدء",
      pause: "إيقاف مؤقت",
      resume: "استئناف",
      restart: "إعادة التشغيل",
      settings: "الإعدادات",
      prep_phase: "التحضير",
      shoot_phase: "الرمي",
      done: "انتهى الوقت",
      name: "اسم المؤقّت المحفوظ",
      name_ph: "مثال: تدريب القاعة",
      fix_fields: "تحقق من الحقول: أحمر ≤ برتقالي ≤ الرمي",
    },
    chronopage: {
      awake_on: "الشاشة تبقى مضاءة",
      awake_off: "السكون غير محظور",
      audio_hint: "المس الشاشة مرة واحدة لتفعيل الصوت",
      controls_title: "ذراع التحكم / لوحة المفاتيح",
      controls_desc: "A: بدء / إيقاف مؤقت · B: إعادة التشغيل (مفتاحا A و B في لوحة المفاتيح يعملان أيضًا).",
      controls_hint: "مفتاح A: إيقاف مؤقت / استئناف · مفتاح B: إعادة التشغيل",
      pad_connected: "ذراع تحكم متصل",
      pad_none: "لم يتم العثور على ذراع تحكم (اضغط على زر)",
      map_play: "بدء / إيقاف مؤقت",
      map_restart: "إعادة التشغيل",
      map_assign: "تعيين",
      map_press: "اضغط على زر…",
      map_default: "القيم الافتراضية",
    },
    delaycam: {
      title: "كاميرا التأخير",
      tile_title: "كاميرا التأخير",
      tile_desc: "كاميرا بتأخير قابل للضبط",
      delay_label: "التأخير",
      switch_camera: "تبديل الكاميرا",
      permission_denied: "تم رفض الوصول إلى الكاميرا. يرجى السماح به في إعدادات المتصفح.",
      no_camera: "لم يتم العثور على كاميرا على هذا الجهاز.",
      starting: "جارٍ تشغيل الكاميرا...",
    },
    social: {
      title: "اجتماعي",
      tab_friends: "الأصدقاء",
      tab_requests: "الطلبات",
      tab_search: "إضافة",
      search_ph: "1234 5678",
      search_hint: "أدخل رمز الصديق المكوّن من 8 أرقام.",
      no_results: "لا حساب لهذا الرمز",
      my_code: "رمز صديقي",
      code_copied: "نُسخ الرمز",
      find: "بحث",
      no_friends: "ليس لديك أصدقاء بعد.",
      no_requests: "لا طلبات معلّقة.",
      add: "إضافة",
      sent: "أُرسلت",
      friend: "صديق",
      accept: "قبول",
      decline: "رفض",
      remove: "إزالة",
      remove_confirm: "إزالة هذا الصديق؟",
      cancel: "إلغاء الطلب",
      incoming: "الواردة",
      outgoing: "الصادرة",
      invitations: "الدعوات",
      invited_you: "يدعوك",
      join: "انضمام",
      request_sent: "أُرسل الطلب",
      now_friends: "أصبحتما صديقين",
      error: "حدث خطأ ما",
    },
    share: {
      button: "مشاركة",
      title: "مشاركة الجلسة",
      pick: "اختر الأصدقاء لإعلامهم",
      send: "إرسال",
      sent_toast: "أُرسلت الدعوة",
      none: "أضف أصدقاء لمشاركة جلساتك.",
    },
    targetcfg: {
      title: "هدفك",
      face: "الوجه",
      full: "كامل",
      trispot_recurve: "Trispot recurve",
      trispot_compound: "Trispot compound",
      x_inner: "X (داخلي)",
      outer_ten: "10 خارجي",
      change: "الهدف",
      confirm: "تأكيد هدفي",
    },
    rules: {
      label: "القواعد",
      title: "مرجع التنسيقات",
      qualification_name: "تأهيل",
      qualification_body: "72 سهمًا في المجموع، على 12 جولة من 6. X=10 (داخلي)، ثم 10, 9، ... 1، M (خارج) = 0. الأعلى مجموعًا يفوز.",
      recurve_name: "مباراة استرداد (أولمبي)",
      recurve_body: "5 أشواط من 3 أسهم. الفائز بالشوط = نقطتان، تعادل = 1 لكل. أول من يصل إلى 6 نقاط يفوز. عند 5-5، تسديدة فاصلة بسهم واحد، الأقرب إلى المركز يفوز.",
      compound_name: "مباراة مركّب",
      compound_body: "5 جولات من 3 أسهم. النتائج تراكمية. الأعلى مجموعًا على 15 سهمًا يفوز. عند التعادل، تسديدة فاصلة الأقرب للمركز.",
      solo_name: "تدريب فردي",
      solo_body: "حدّد عدد الجولات والأسهم كما تشاء. لا خصم، مجرد نتيجتك.",
    },
    match_create: {
      title: "مباراة جديدة",
      step1: "الخطوة 1",
      step1_title: "اختر تنسيقًا",
      qualification: "تأهيل",
      qualification_desc: "72 سهمًا · 12 جولة من 6",
      recurve: "مباراة استرداد",
      recurve_desc: "نظام أشواط · 5 أشواط من 3 · أول من يصل إلى 6",
      compound: "مباراة مركّب",
      compound_desc: "تراكمي · 5 جولات من 3",
      step2: "الخطوة 2",
      step2_title: "عدّل الإعدادات",
      sets: "أشواط",
      ends: "جولات",
      arrows_per_end: "أسهم لكل جولة",
      cta_create: "أنشئ رمز الغرفة",
      creating: "جارٍ الإنشاء...",
      error_create: "تعذر إنشاء المباراة",
    },
    match_join: {
      title: "انضم للمباراة",
      label: "أدخل الرمز",
      heading: "لديك رمز غرفة؟",
      desc: "اكتب رمز الستة أحرف الذي شاركه المستضيف.",
      cta: "انضم",
      joining: "جارٍ الانضمام...",
      not_found: "لم يتم العثور على المباراة",
    },
    match_live: {
      leave: "مغادرة",
      leave_confirm: "مغادرة المباراة؟ ستُحذف نتائجك.",
      waiting: "غرفة الانتظار",
      live: "مباشر",
      finished: "انتهت",
      share_code: "شارك هذا الرمز",
      players_joined: "لاعبون انضموا",
      start_match: "ابدأ المباراة",
      started: "بدأت المباراة",
      start_error: "تعذر البدء",
      finish_match: "إنهاء المباراة",
      finished_toast: "انتهت المباراة",
      finish_error: "تعذر الإنهاء",
      end_match: "أنهِ المباراة",
      end: "جولة",
      arrow: "سهم",
      reset_last: "تراجع عن الأخير",
      reset_error: "تعذر التراجع",
      all_shot: "تم تسديد كل الأسهم!",
      final_score: "النتيجة النهائية:",
      you: "أنت",
      opponent: "الخصم",
      set_points: "نقاط الأشواط:",
      total_arrows: "مجموع الأسهم:",
      submit_error: "تعذر إرسال النتيجة",
      tiebreak_title: "تسديدة فاصلة",
      tiebreak_desc_recurve: "تعادل 5-5. سدّد سهمًا واحدًا، الأقرب للمركز يفوز.",
      tiebreak_desc_compound: "تعادل. سدّد سهمًا فاصلًا لحسم الفوز.",
      shootoff_waiting: "بانتظار الخصم...",
      shootoff_shot: "تم تسديد السهم",
      still_tied: "لا يزال التعادل قائمًا. على المستضيف اختيار الأقرب للمركز.",
      who_closest: "من الأقرب للمركز؟",
      declare_winner: "إعلان الفائز",
      winner_declared: "تم إعلان الفائز",
      winner: "الفائز",
      cancel_winner: "إلغاء الاختيار",
    },
    solo_setup: {
      title: "تدريب فردي",
      label: "تدريب",
      heading: "اضبط جلستك",
      ends: "جولات",
      arrows_per_end: "أسهم لكل جولة",
      cta: "ابدأ الرمي",
      creating: "جارٍ البدء...",
      error: "تعذر بدء الجلسة",
    },
    solo_live: {
      back: "رجوع",
      total: "المجموع",
      end: "جولة",
      arrow: "سهم",
      finish: "إنهاء الجلسة",
      finished: "انتهت الجلسة",
      final: "النتيجة النهائية:",
      end_early: "إنهاء",
      toast_finished: "انتهت الجلسة",
      submit_error: "تعذر الإرسال",
    },
    history: {
      title: "السجل",
      label: "الأرشيف",
      heading: "جلساتك",
      empty: "لا توجد جلسات بعد. ابدأ واحدة من لوحة التحكم.",
      open: "فتح ←",
      players_suffix: "لاعبون",
      match_word: "مباراة",
      delete: "حذف",
      delete_confirm_title: "حذف هذا العنصر؟",
      delete_confirm_desc: "سيُزال من سجلك. لا يمكن التراجع.",
      delete_cancel: "إلغاء",
      delete_ok: "حذف",
      deleted: "تم الحذف",
      delete_error: "تعذر الحذف",
    },
    format: {
      qualification: "تأهيل",
      recurve: "استرداد",
      compound: "مركّب",
      solo: "فردي",
    },
  },
};

export function translate(lang, path) {
  const parts = path.split(".");
  let cur = dict[lang] || dict.fr;
  for (const p of parts) {
    if (cur && typeof cur === "object" && p in cur) cur = cur[p];
    else return path;
  }
  return cur;
}

export default dict;
